// extracted by mini-css-extract-plugin
export default {"root":"MetaNavigation_root__FT0g3"};